import { Select, Radio, Space } from 'antd';
import { v4 as uuid } from 'uuid';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { BUTTON_VARIANT_DARK } from '../../../../../../../components/forms/ZorbaButton/constants';
import { ZorbaButton } from '../../../../../../../components/forms';
import { setAppliedFilters } from '../../../../../../../reducers/Offer/actions';

import { options } from '../constants';

import '../index.scss';

export const MarketBuilder = ({ onApplyFilter }) => {
  const dispatch = useDispatch();
  const { appliedFilters, markets } = useSelector(
    ({ OfferReducer }) => OfferReducer,
  );
  const [defaultRadioValue] = Object.keys(appliedFilters.market ?? {});
  const defaultSelectValue = defaultRadioValue
    ? appliedFilters.market[defaultRadioValue]
    : [];

  const [radioValue, setRadioValue] = useState(defaultRadioValue);
  const [selectedMarkets, setSelectedMarkets] = useState(defaultSelectValue);
  const marketOptions = markets.map((market) => ({
    label: market,
    value: market,
  }));
  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
  };

  const handleSelectChange = (newValue) => {
    setSelectedMarkets(newValue);
  };

  const isApplyButtonDisabled = !radioValue || !selectedMarkets.length;
  const handleApply = () => {
    dispatch(
      setAppliedFilters('market', {
        [radioValue]: selectedMarkets,
      }),
    );
    onApplyFilter();
  };

  return (
    <div className="builder-container">
      <h3>Market</h3>
      <div className="options-container">
        <Radio.Group onChange={handleRadioChange} value={radioValue}>
          <Space direction="vertical">
            {options.map((option) => (
              <Radio key={uuid()} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        {radioValue && (
          <Select
            mode="tags"
            className="select"
            placeholder="Select markets"
            onChange={(newValue) => handleSelectChange(newValue)}
            value={selectedMarkets}
            options={marketOptions}
          />
        )}
      </div>
      <ZorbaButton
        variant={BUTTON_VARIANT_DARK}
        disabled={isApplyButtonDisabled}
        onClick={handleApply}
        fullWidth={false}
      >
        Apply
      </ZorbaButton>
    </div>
  );
};
